<template>
  <div class="login-container">
    <div class="login-background"></div>
    <el-card class="login-card">
      <div class="login-header">
        <div class="logo-container">
          <!-- 这里放置 Logo -->
          <img src="@/assets/logo1.png" alt="logo" class="logo" />
        </div>
        <h2 class="system-title">焦化11种隐患人管理后台</h2>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" @keyup.enter.native="handleLogin">
        <el-form-item prop="account">
          <el-input 
            v-model="loginForm.account" 
            prefix-icon="el-icon-user"
            placeholder="请输入账号"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="captcha-container">
            <el-input 
              v-model="loginForm.captcha" 
              prefix-icon="el-icon-key"
              placeholder="请输入验证码"
              class="captcha-input"
              maxlength="4">
            </el-input>
            <div class="captcha-image" @click="refreshCaptcha" title="点击刷新验证码">
              <template v-if="captchaUrl && captchaUrl !== 'loading'">
                <img :src="captchaUrl" alt="验证码" />
              </template>
              <template v-else-if="captchaUrl === 'loading'">
                <div class="captcha-loading">
                  <i class="el-icon-loading"></i>
                  <span>加载中...</span>
                </div>
              </template>
              <template v-else>
                <div class="captcha-placeholder">
                  <i class="el-icon-refresh"></i>
                  <span>点击获取验证码</span>
                </div>
              </template>
            </div>
          </div>
        </el-form-item>
        <!-- 隐藏的终端类型字段 -->
        <input type="hidden" v-model="loginForm.terminalType" />
        <el-form-item>
          <el-button 
            type="primary" 
            @click="handleLogin" 
            style="width: 100%"
            :loading="loading">
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="login-footer">
        <p>© 2023 健康填报系统 版权所有</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCaptcha } from '@/api/user'
import { asyncRoutes, resetRouter, addNotFoundRoute } from '@/router'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        captcha: '',
        terminalType: 1 // 添加终端类型参数
      },
      loading: false,
      captchaUrl: '', // 验证码图片URL
      captchaRetryCount: 0, // 验证码重试计数器
      maxRetryCount: 3, // 最大重试次数
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '验证码长度为4位', trigger: 'blur' }
        ]
      },
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    // 如果已登录，直接跳转到首页
    if (this.$store.getters.token) {
      this.$router.push('/')
    } else {
      // 只有在未登录状态才获取验证码，避免不必要的请求
      this.refreshCaptcha(true) // 传入true表示是初始加载，不显示错误提示
    }
  },
  methods: {
    // 刷新验证码
    refreshCaptcha(isInitialLoad = false) {
      // 清空验证码输入框
      this.loginForm.captcha = '';
      
      // 显示加载中的状态
      this.captchaUrl = 'loading';
      
      // 调用后端接口获取验证码
      getCaptcha().then(res => {
        console.log('验证码数据:', res);
        // 直接使用返回的数据
        if (res && res.image) {
          this.captchaUrl = res.image;
        } else {
          console.warn('验证码返回格式异常');
          this.$message.error('获取验证码失败，请刷新重试');
          this.captchaUrl = '';
        }
      }).catch(error => {
        console.error('获取验证码失败:', error);
        this.$message.error('获取验证码失败，请刷新重试');
        this.captchaUrl = '';
      });
    },
    
    // 生成随机颜色
    getRandomColor(min, max) {
      const r = Math.floor(Math.random() * (max - min + 1)) + min;
      const g = Math.floor(Math.random() * (max - min + 1)) + min;
      const b = Math.floor(Math.random() * (max - min + 1)) + min;
      return `rgb(${r},${g},${b})`;
    },
    
    // 处理登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 检查验证码是否已加载
          if (!this.captchaUrl || this.captchaUrl === 'loading') {
            this.$message.error('验证码尚未加载完成，请稍后再试');
            if (!this.captchaUrl) {
              this.refreshCaptcha();
            }
            return;
          }
          
          this.loading = true
          
          // 正常登录流程
          this.$store.dispatch('user/login', this.loginForm)
            .then(res => {
              console.log('登录成功，响应数据:', res);
              this.loading = false
              
              // 显示登录成功消息
              this.$message({
                message: '登录成功，欢迎回来！',
                type: 'success',
                duration: 2000
              })
              
              // 检查是否有权限数据
              if (!res.permissions || res.permissions.length === 0) {
                console.warn('后端未返回权限数据');
                // 显示权限为空的错误提示
                this.$message.error('您没有任何菜单权限，请联系管理员');
                return;
              }
              
              console.log('使用后端返回的权限数据:', res.permissions);
              
              // 重新生成路由
              this.$store.dispatch('permission/generateRoutes', this.$store.getters.roles)
                .then(routes => {
                  console.log('生成的路由:', routes);
                  
                  // 如果没有生成任何路由，提示错误
                  if (!routes || routes.length === 0) {
                    this.$message.error('无法生成有效的菜单，请联系管理员');
                    return;
                  }
                  
                  // 重置路由
                  resetRouter();
                  
                  // 添加新路由
                  routes.forEach(route => {
                    this.$router.addRoute(route);
                  });
                  
                  // 获取第一个可用的路由路径
                  const firstRoutePath = this.getFirstAvailableRoute(routes);
                  console.log('跳转到第一个可用路由:', firstRoutePath);
                  
                  // 如果没有可用路由，提示错误
                  if (!firstRoutePath) {
                    this.$message.error('没有可用的菜单页面，请联系管理员');
                    return;
                  }
                  
                  // 等待路由注册完成
                  this.$nextTick(() => {
                    // 打印所有路由
                    console.log('所有路由:', this.$router.getRoutes().map(r => r.path));
                    
                    // 确定跳转目标
                    let redirectPath = firstRoutePath;
                    
                    // 如果有重定向参数，优先使用重定向参数
                    if (this.redirect && this.redirect !== '/login') {
                      // 检查重定向路径是否在可用路由中
                      const isRedirectAvailable = this.$router.getRoutes().some(r => r.path === this.redirect);
                      if (isRedirectAvailable) {
                        redirectPath = this.redirect;
                        console.log('使用重定向参数:', redirectPath);
                      } else {
                        console.log('重定向路径不可用，使用第一个可用路由');
                      }
                    }
                    
                    console.log('最终跳转路径:', redirectPath);
                    
                    // 使用直接跳转方式，避免路由问题
                    setTimeout(() => {
                      // 添加通配符路由，确保在所有路由注册完成后再添加
                      addNotFoundRoute();
                      
                      // 使用router.replace而不是window.location.replace
                      this.$router.replace(redirectPath);
                    }, 300);
                  });
                })
                .catch(error => {
                  console.error('生成路由失败:', error);
                  this.$router.push('/dashboard');
                });
            })
            .catch(error => {
              console.error('登录失败:', error)
              this.loading = false
              
              // 刷新验证码
              this.refreshCaptcha()
              
              // 显示错误提示
              this.$message.error(error.message || '登录失败，请检查账号密码和验证码')
            })
        }
      })
    },
    
    // 获取第一个可用的路由路径
    getFirstAvailableRoute(routes) {
      if (!routes || routes.length === 0) {
        console.warn('没有可用的路由');
        return null;
      }
      
      console.log('可用路由列表:', JSON.stringify(routes, null, 2));
      
      // 获取后端返回的权限列表
      const permissions = this.$store.getters.permissions;
      if (Array.isArray(permissions) && permissions.length > 0) {
        // 尝试使用第一个有path的权限作为跳转目标
        for (const permission of permissions) {
          if (permission.path) {
            // 从组件路径中提取路由路径
            let path = permission.path;
            if (path.startsWith('/views/')) {
              path = path.substring(7);
            }
            path = path.replace(/\/[Ii]ndex$/, '');
            if (!path.startsWith('/')) {
              path = '/' + path;
            }
            
            // 检查路径是否在已注册的路由中
            const isPathRegistered = this.$router.getRoutes().some(r => r.path === path);
            if (isPathRegistered) {
              console.log('使用权限列表中的第一个有效路径:', path);
              return path;
            } else {
              console.log('权限路径未注册为路由:', path);
            }
          }
        }
      }
      
      // 如果权限列表中没有可用路径，则使用路由列表
      // 遍历路由，找到第一个可用的路由
      for (const route of routes) {
        console.log('检查路由:', route.path);
        
        // 如果路由有子路由，且第一个子路由有path，则返回完整路径
        if (route.children && route.children.length > 0) {
          const childRoute = route.children[0];
          console.log('检查子路由:', childRoute);
          
          if (childRoute && childRoute.path !== undefined) {
            // 如果子路由path为空字符串，则直接返回父路由路径
            if (childRoute.path === '') {
              console.log('使用父路由路径:', route.path);
              return route.path;
            }
            // 构建完整路径
            const fullPath = `${route.path}/${childRoute.path.replace(/^\//, '')}`;
            console.log('使用完整路径:', fullPath);
            return fullPath;
          }
        }
        
        // 如果路由本身有path且不是根路径，则返回该路径
        if (route.path && route.path !== '/') {
          console.log('使用路由自身路径:', route.path);
          return route.path;
        }
      }
      
      // 如果没有找到可用路由，返回null
      console.warn('未找到可用路由');
      return null;
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: #f0f2f5;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  opacity: 0.2;
  z-index: 0;
}

.login-card {
  width: 400px;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.95);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo-container {
  margin-bottom: 15px;
}

.logo {
  width: 84px;
  height: 84px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 5px;
  background-color: white;
}

.system-title {
  color: #409EFF;
  font-size: 22px;
  margin: 15px 0;
  font-weight: 600;
  letter-spacing: 1px;
}

.captcha-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.captcha-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.captcha-placeholder {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 12px;
  width: 100%;
  border-radius: 4px;
}

.captcha-placeholder i {
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 0;
}

.captcha-placeholder span {
  line-height: 1;
}

.captcha-loading {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f5f7fa;
  color: #409EFF;
  font-size: 12px;
  width: 100%;
  border-radius: 4px;
}

.captcha-loading i {
  font-size: 16px;
  margin-right: 5px;
}

.captcha-loading span {
  line-height: 1;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
  color: #909399;
  font-size: 12px;
}

/* 添加一些动画效果 */
.el-button {
  transition: all 0.3s;
  height: 44px;
  font-size: 16px;
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.el-input__inner {
  height: 44px;
}

.logo {
  transition: all 0.3s;
}

.logo:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* 响应式设计 */
@media (max-width: 576px) {
  .login-card {
    width: 90%;
    max-width: 400px;
    padding: 15px;
  }
  
  .logo {
    width: 70px;
    height: 70px;
  }
  
  .system-title {
    font-size: 20px;
  }
}

/* 添加入场动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card {
  animation: fadeIn 0.8s ease-out;
}
</style>
